import React from 'react';
import styles from './ToggleButton.module.css';

interface ToggleButtonProps {
  id: string;
  isOn: boolean;
  onToggle: () => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  id,
  isOn,
  onToggle,
  label,
  disabled = false,
  className = '',
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onToggle();
    }
  };

  const combinedClassName = `${styles.toggleButtonContainer} ${className}`;

  return (
    <div className={combinedClassName}>
      {label && (
        <label htmlFor={id} className={`input-label ${styles.toggleLabel}`}>
          {label}
        </label>
      )}
      <button
        type="button"
        id={id}
        role="switch"
        aria-checked={isOn}
        onClick={handleToggle}
        disabled={disabled}
        className={`${styles.toggleSwitch} ${isOn ? styles.on : styles.off} ${
          disabled ? styles.disabled : ''
        }`}
      >
        <span className={styles.toggleHandle} />
      </button>
    </div>
  );
};

export default ToggleButton;